var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-help" },
    [
      _vm.roleVo.roleType === 0 ||
      _vm.roleVo.roleType === 1 ||
      _vm.roleVo.roleType === 2 ||
      _vm.roleVo.roleType === 8 ||
      _vm.roleVo.roleType === 12 ||
      _vm.roleVo.roleType === 10 ||
      _vm.roleVo.roleType === 11
        ? _c("user-help-person")
        : _vm._e(),
      _vm._v(" "),
      _vm.roleVo.roleType === 7 ||
      _vm.roleVo.roleType === 3 ||
      _vm.roleVo.roleType === 4 ||
      _vm.roleVo.roleType === 14
        ? _c("user-help-teacher")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }